import { VFlow } from 'bold-ui'
import { turquoise } from 'bold-ui/lib/styles/colors'
import { IconLabelButton } from 'components/IconLabelButton'
import triaIcon from 'images/acompanhamento/acompanhamento-condicao-saude/ic_tria.svg'
import { useField } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  TipoVulnerabilidadeEnum,
} from '../../model/model-acompanhamentoCondicaoSaude'
import { AcompanhamentoCondicaoSaudeTriaFilterGroup } from './AcompanhamentoCondicaoSaudeTriaFilterGroup'

interface VulnerabilidadeFilterGroupProps {
  meta: MetaRoot<AcompanhamentoCondicaoSaudeFormModel>
}

export function VulnerabilidadeFilterGroup(props: VulnerabilidadeFilterGroupProps) {
  const { meta } = props

  const {
    input: { value: vulnerabilidadeSelected, onChange: vulnerabilidadeSelectedOnChange },
  } = useField<TipoVulnerabilidadeEnum>(meta.tipoVulnerabilidadeSelected.absolutePath())

  const isBotaoTriaAtivo = vulnerabilidadeSelected === TipoVulnerabilidadeEnum.TRIA

  const handleTriaClick = () => {
    vulnerabilidadeSelectedOnChange(isBotaoTriaAtivo ? undefined : TipoVulnerabilidadeEnum.TRIA)
  }

  // TODO Royal Flush: Discutir quando remover o IvcfButton, pois é utilizado no SOAP também.
  return (
    <VFlow vSpacing={0.5}>
      <IconLabelButton
        isActive={isBotaoTriaAtivo}
        handleClick={handleTriaClick}
        img={triaIcon}
        alt='Triagem para Risco de Insegurança Alimentar'
        title='TRIA'
        mainColor={turquoise}
      />
      {isBotaoTriaAtivo && <AcompanhamentoCondicaoSaudeTriaFilterGroup meta={meta} />}
    </VFlow>
  )
}
